"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Environment = void 0;
var js_logger_1 = __importDefault(require("js-logger"));
var utils_1 = require("./utils");
js_logger_1.default.useDefaults();
var Environment = (function () {
    function Environment() {
    }
    Object.defineProperty(Environment, "apiRoot", {
        get: function () {
            if (!this._apiRoot) {
                throw new Error("API Root not set");
            }
            return this._apiRoot;
        },
        set: function (value) {
            if (value.endsWith("/")) {
                value = value.replace(/\/$/, "");
            }
            this._apiRoot = value;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Environment, "authToken", {
        get: function () {
            return this._authToken;
        },
        set: function (value) {
            this._authToken = value;
            this._parsedToken = utils_1.parseJsonWebToken(value);
        },
        enumerable: false,
        configurable: true
    });
    Environment.clearAuthToken = function () {
        this._authToken = undefined;
        this._parsedToken = undefined;
    };
    Object.defineProperty(Environment, "getParsedAuthToken", {
        get: function () {
            return this._parsedToken;
        },
        enumerable: false,
        configurable: true
    });
    Environment.isTokenValid = function () {
        if (!this._parsedToken) {
            return false;
        }
        return new Date(this._parsedToken.exp * 1000) > new Date();
    };
    Environment.getParticipantId = function () {
        var _a;
        return (_a = this._parsedToken) === null || _a === void 0 ? void 0 : _a.participantId;
    };
    Environment.getRoles = function () {
        var _a, _b;
        return ((_b = (_a = this._parsedToken) === null || _a === void 0 ? void 0 : _a.authorities) === null || _b === void 0 ? void 0 : _b.map(function (a) { return a.authority; })) || [];
    };
    Environment.hasRoleAccess = function (roles) {
        var _a, _b;
        return !!((_b = (_a = this._parsedToken) === null || _a === void 0 ? void 0 : _a.authorities) === null || _b === void 0 ? void 0 : _b.some(function (a) {
            return roles.includes(a.authority);
        }));
    };
    Environment.hasGroupAccess = function (groupIds, roles, every) {
        var _this = this;
        if (every === void 0) { every = false; }
        if (groupIds.length === 0)
            return true;
        if (every) {
            return groupIds.every(function (id) { var _a, _b; return (_b = (_a = _this._parsedToken) === null || _a === void 0 ? void 0 : _a.authorities) === null || _b === void 0 ? void 0 : _b.some(function (a) {
                return roles.includes(a.authority) && (a.isGlobal || a.groups.includes(id));
            }); });
        }
        return groupIds.some(function (id) { var _a, _b; return (_b = (_a = _this._parsedToken) === null || _a === void 0 ? void 0 : _a.authorities) === null || _b === void 0 ? void 0 : _b.some(function (a) {
            return roles.includes(a.authority) && (a.isGlobal || a.groups.includes(id));
        }); });
    };
    Environment.endpoint = function (path) {
        if (!path.startsWith("/")) {
            path = "/" + path;
        }
        return "" + Environment.apiRoot + path;
    };
    Environment.setLogLevel = function (level) {
        switch (level) {
            case "debug":
                js_logger_1.default.setLevel(js_logger_1.default.DEBUG);
                break;
            case "info":
                js_logger_1.default.setLevel(js_logger_1.default.INFO);
                break;
            case "warn":
                js_logger_1.default.setLevel(js_logger_1.default.WARN);
                break;
            case "error":
                js_logger_1.default.setLevel(js_logger_1.default.ERROR);
                break;
            case "trace":
                js_logger_1.default.setLevel(js_logger_1.default.TRACE);
                break;
            default:
                js_logger_1.default.setLevel(js_logger_1.default.WARN);
        }
    };
    return Environment;
}());
exports.Environment = Environment;
//# sourceMappingURL=environment.js.map